import { render, staticRenderFns } from "./MenuDrawerContainer.vue?vue&type=template&id=23de7d78&scoped=true&"
import script from "./MenuDrawerContainer.vue?vue&type=script&lang=js&"
export * from "./MenuDrawerContainer.vue?vue&type=script&lang=js&"
import style0 from "./MenuDrawerContainer.vue?vue&type=style&index=0&id=23de7d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de7d78",
  null
  
)

export default component.exports